import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Dropdown,
  MenuButton,
  Menu,
  MenuItem,
  ListItemDecorator,
  CircularProgress,
} from "@mui/joy";

type ExportAction = {
  label: string;
  onClick: () => void | Promise<void>;
};

type ExportDropdownProps = {
  items: ExportAction[];
  loading?: boolean;
};

const ExportDropdown: React.FC<ExportDropdownProps> = ({
  items,
  loading = false,
}) => {
  return (
    <Dropdown>
      <MenuButton
        variant="outlined"
        color="neutral"
        disabled={loading}
        startDecorator={
          loading ? (
            <CircularProgress size="sm" thickness={2} />
          ) : (
            <DownloadIcon />
          )
        }
        sx={{
          width: { xs: "100%", sm: "auto" },
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        {loading ? "Exporting..." : "Export"}
      </MenuButton>
      <Menu placement="bottom-end">
        {items.map((item) => (
          <MenuItem key={item.label} onClick={item.onClick} disabled={loading}>
            <ListItemDecorator>
              <DownloadIcon fontSize="small" />
            </ListItemDecorator>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
};

export default ExportDropdown;
